export default {
  order: 1,
  name: "Inventory Dashboard",
  icon: "inventory",
  to: "/inventory/main",
  enabled: true,
  topMenu: true,
};
